import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { Reveal, Eyebrow } from "./Reveal";
import { FAQS } from "../data/content";

export const FAQ = () => (
  <section id="faq" data-testid="section-faq" className="py-24 sm:py-32">
    <div className="max-w-4xl mx-auto px-5 sm:px-8">
      <Reveal className="mb-14 text-center">
        <div className="flex justify-center">
          <Eyebrow index="09">Questions</Eyebrow>
        </div>
        <h2 className="font-serif-ed font-normal text-3xl sm:text-4xl lg:text-5xl mt-6 text-[#2A1F16]">
          Before you <em className="text-[#96754D]">book</em>
        </h2>
        <p className="mt-4 text-[15px] text-[#6B5A49]">
          Everything brides usually ask — answered honestly.
        </p>
      </Reveal>

      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="border-t border-[#E9DCC8]">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="border-b border-[#E9DCC8]"
              data-testid={`faq-item-${i + 1}`}
            >
              <AccordionTrigger
                data-testid={`faq-question-${i + 1}`}
                className="py-6 font-serif-ed font-normal text-lg sm:text-xl text-[#2A1F16] hover:text-[#B8893B] hover:no-underline transition-colors duration-300 [&>svg]:text-[#B8893B]"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-answer-${i + 1}`}
                className="text-sm sm:text-[15px] leading-relaxed text-[#6B5A49] pb-6 max-w-2xl"
              >
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
